import React, {FC, useContext, useEffect} from 'react';

import {Route, Routes, useNavigate} from 'react-router-dom';
import {AppSettingsContext, ROUTES} from 'core';
import {selectUser} from 'store/user/userSlice';
import {RootState, useAppSelector} from 'store';
import {FullScreenLoadingBox} from 'components';
import {useDispatch} from "react-redux";

import {OidcClient, OidcLogout, OidcProvider} from '@britishcouncil/react-oidc-auth';

import {LoginCallback, LogoutCallback, LoginInit} from './';

export const AuthProvider: FC = ({children}) => {
    const navigate = useNavigate();
    const loggedUser = useAppSelector(selectUser);
    const appSettings = useContext(AppSettingsContext);
    
    const userManagerSettings: OidcClient.UserManagerSettings = {
        ...appSettings.userManager,
        userStore: new OidcClient.WebStorageStateStore({ store: window.localStorage }),
    };
    
    useEffect(() => {
        if (loggedUser && !loggedUser.isFullyRegistered) {
            navigate(ROUTES.SIGN_IN, {});
        }
    }, [loggedUser, navigate]);

    return (
        <OidcProvider {...userManagerSettings}>
            <Routes>
                <Route path={ROUTES.LOGIN_REDIRECT} element={<LoginCallback/>}/>
                <Route path={ROUTES.LOGIN_INIT} element={<LoginInit/>}/>
                <Route
                    path={ROUTES.LOGOUT}
                    element={
                        <OidcLogout>
                            <FullScreenLoadingBox/>
                        </OidcLogout>
                    }
                />
                <Route path={ROUTES.LOGOUT_REDIRECT} element={<LogoutCallback/>}/>
                <Route path="*" element={children}/>
            </Routes>
        </OidcProvider>
    );
};